/* ============
 * All Recipe Types
 * ============
 *
 * All recipe types.
 */

import Vue from 'vue';
import store from '../../store';
import recipeTypeTransformer from '../../transformers/recipeType';

const success = ({ data }, resolve) => {
  const recipeTypes = recipeTypeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllRecipeTypes', recipeTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display recipe types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('production/recipe_types')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeType/all.js